<template>
    <div>
        <img :src="image.path" :alt="image.title" @click="$emit('pick', image.id)"
             class="image-picker__image image-item__image" width="200"/>

        <div class="image-item__controls">
            <custom-button @click="remove(image.id)" iconic><span icon remove></span>Odebrat</custom-button>
        </div>
    </div>
</template>

<script>
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'ImageItem',
    components: {CustomButton},
    props:      {
        image:      {
            type:     Object,
            required: true,
        },
        buildingId: {
            type:     String,
            required: true,
        }
    },
    methods:    {
        remove(imageId) {
            this.$modal.show('dialog', {
                text:    'Opravdu chcete soubor <strong>' + this.image.title + '</strong> odpojit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odpojit',
                        handler: () => {
                            this.$store.dispatch('projects/project/building/removeImages', {
                                buildingId: this.buildingId,
                                imageIds:   [imageId]
                            })
                                .catch((message) => this.$dmv.notifyError(message));
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        }
    }
}
</script>
